import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { logWarning } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { intl, showMessageId } from '../helpers/intl';
import { collectMissingDynamicTerm } from '../services/dynamicTermSuggestion/dynamicTermSuggestionStore';

export const SafeFormattedMessageWithId: FC<{
  id?: string;
  values?: Record<string, string>;
  basePath?: string;
}> = ({ id, values, basePath }) => {
  'use no memo';

  if (!id) {
    return null;
  }

  const fullMessageId = [basePath, id].filter((part) => !!part).join('');
  const isMessageExist = !intl || !!intl.messages[fullMessageId];
  const messageId = isMessageExist ? fullMessageId : id;

  if (!isMessageExist) {
    logWarning(
      `[PO-EDITOR]: message "${fullMessageId}" does not have a corresponding message in Dynamic messages.`,
    );

    collectMissingDynamicTerm({ messageId: fullMessageId });
  }

  const el = React.createElement(FormattedMessage, {
    ...{ id: messageId, values },
  });
  const span = React.createElement('span', { title: id }, el);

  if (showMessageId) {
    return span;
  }

  return el;
};
